export default __webpack_public_path__ + "static/media/reviewLeftLight.b821672a.svg";